<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Incoming Phone Call</v-card-title>

        <v-card-text>
            Incoming call from {{call_from_label}}.
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Dismiss
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            transport_system_call_id: 'not-set',
            call_from_label: '',
            dialog: false,
        }
    },

    created() 
    {
        this.$event_bus.$on('call-start-ringing',this.showDialog);
        this.$event_bus.$on('call-stop-ringing',this.stopRinging);
    },

    beforeDestroy() {
        this.$event_bus.$off('call-start-ringing',this.showDialog);
        this.$event_bus.$off('call-stop-ringing',this.stopRinging);
    },

    methods: {

        showDialog(signal)
        {
            if ( signal.forward_to_employee_id != this.$rc.$state.employee_id )
                return;

            this.transport_system_call_id = signal.transport_system_call_id;
            this.call_from_label = signal.call_from_label;

            this.dialog = true;
        },

        stopRinging(signal)
        {
            if ( this.dialog != true )
                return;

            if ( this.transport_system_call_id != signal.transport_system_call_id )
                return;
            
            this.dialog = false;
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>